import { render, staticRenderFns } from "./Datepicker.vue?vue&type=template&id=96e04ace&scoped=true&"
import script from "./Datepicker.vue?vue&type=script&lang=js&"
export * from "./Datepicker.vue?vue&type=script&lang=js&"
import style0 from "./Datepicker.vue?vue&type=style&index=0&id=96e04ace&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96e04ace",
  null
  
)

export default component.exports